export const SERVICE_CODE = 'BANK' + '_SERVICE';
